/**
 * The rows the save confirmation lists — and, by its length, whether there is
 * anything to save at all.
 *
 * The component uses this for both the confirmation's contents and the Save
 * button's enabled state, so the two cannot disagree about whether a change is
 * pending. Units travel with the values because "3.5 → 20" and "2 → 1.5" are
 * not self-describing in a list.
 */
export const thresholdDiff = (saved, next) => {
    if (!saved)
        return [];
    const rows = [];
    const add = (label, from, to, suffix = '') => {
        if (from !== to)
            rows.push({ label, from: `${from}${suffix}`, to: `${to}${suffix}` });
    };
    add('Head deviation', saved.head_deviation_deg, next.headDeg, '°');
    add('Eye deviation', saved.gaze_deviation, next.gazeDev);
    add('Must hold for', saved.dwell_seconds, next.dwell, 's');
    add('Capture width', saved.capture_width, next.captureWidth, 'px');
    return rows;
};
